const fallbackFormatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' })

/**
 * Formats a price based on a config formatter for topUp
 * If none is defined in config, a default formatter is used with euro based on german locale
 */
export default {
  computed: {
    priceFormatter: function () {
      return this.$config.formatter?.topUpCurrencyFormatter || fallbackFormatter
    }
  },
  methods: {
    price: function (price) {
      return this.priceFormatter.format(parseInt(price) / 100)
    }
  }
}
